<template>
  <div>
    <div class="top-breadcrumb">
      <ol class="breadcrumb" style="background-color: white">
        <li class="breadcrumb-item" style="margin-left: 15px">
          <router-link to="" style="color: #8cc63f !important">
            Investors Management
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link
            style="color: #8cc63f !important"
            :to="'/' + authUser.userable_type + '/investors'"
            >Investors</router-link
          >
        </li>
        <li class="breadcrumb-item">
          <router-link
            style="color: #8cc63f !important"
            :to="'/' + authUser.userable_type + '/investor/' + investorID"
            >{{ investorCode }}</router-link
          >
        </li>
      </ol>
    </div>
    <spinner v-if="searchingInvestor" />

    <div
      v-else
      style="
        display: flex;
        align-items: center;
        flex-direction: column;
        margin-top: 60px;
      "
    >
      <div class="col-10">
        <md-card
          class="md-card-stats"
          style="
            min-height: 75px;
            border-radius: 50px;
            display: flex;
            align-items: center;
            flex-direction: row !important;
          "
        >
          <div style="padding-left: 50px; font-size: 18px" class="col-6">
            {{ investorCode }}
          </div>
          <div class="col-6" style="text-align: end; padding-right: 50px">
            <button
              style="border-radius: 30px; padding: 6px 12px; margin-right: 10px"
              type="button"
              class="btn btn-info"
              @click="viewAsInvestor()"
            >
              <i style="padding-top: 5px; color: white" class="fa fa-eye"></i>
            </button>
            <button
              style="border-radius: 30px; padding: 6px 12px; margin-right: 10px"
              type="button"
              class="btn btn-warning"
              @click="redirectToUpdateInvestor()"
            >
              <i
                style="padding-top: 5px; color: white"
                class="fa fa-arrow-up"
              ></i>
            </button>
            <button
              style="border-radius: 30px; padding: 6px 12px"
              @click="deleteInvestor()"
              type="button"
              class="btn btn-danger"
            >
              <i style="padding-top: 5px" class="fa fa-trash"></i>
            </button>
          </div>
        </md-card>
      </div>

      <div class="col-10">
        <md-card
          class="md-card-stats"
          style="
            border-top-right-radius: 30px;
            border-top-left-radius: 30px;
            display: flex;
            justify-content: center;
            margin-bottom: 15px;
          "
        >
          <div
            style="
              display: flex;
              align-items: center;
              flex-direction: row !important;
              min-height: 75px;
            "
          >
            <div
              style="
                padding-left: 50px;
                font-size: 18px;
                display: flex;
                align-items: center;
                cursor: pointer;
              "
              @click="toggleInvestorContracts()"
              class="col-6"
            >
              Contracts
              <i
                style="font-size: 10px; padding-left: 20px"
                :class="
                  showInvestorContracts ? 'fa fa-arrow-up' : 'fa fa-arrow-down'
                "
              ></i>
            </div>
          </div>
          <div
            :style="showInvestorContracts ? 'display: block' : 'display: none'"
            style="min-height: 100px"
          >
            <div class="col-12 investorInfoClass" style="padding-bottom: 25px">
              <table style="width: 100%">
                <thead>
                  <tr style="text-align: center">
                    <th>#</th>
                    <th>Code</th>
                    <th>Status</th>
                    <th>Plan</th>
                    <th>Value</th>
                    <th>Start</th>
                    <th>End</th>
                    <th>Length</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    style="text-align: center"
                    v-for="(contract, key) in activeInvestor.contracts"
                    :key="key"
                  >
                    <td>{{ key + 1 }}</td>
                    <td>{{ contract.code }}</td>

                    <td>
                      {{
                        statusList.find((status) => {
                          return status.id == contract.status;
                        }).name
                      }}
                    </td>
                    <td>
                      {{ contract.plan_name }}
                    </td>
                    <td>
                      {{ fixNumberView(contract.invested_principal) }}
                      {{ contract.currency_code }}
                    </td>
                    <td>
                      {{ contract.start_date }}
                    </td>
                    <td>
                      {{ contract.maturity_date }}
                    </td>
                    <td>
                      {{
                        getContractDuration(
                          contract.start_date,
                          contract.maturity_date
                        )
                      }}
                    </td>
                    <td>
                      <i
                        style="cursor: pointer"
                        @click="redirectToUpdateContract(contract)"
                        class="fa fa-edit"
                      ></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </md-card>
      </div>
      <div class="col-10">
        <md-card
          class="md-card-stats"
          style="
            display: flex;
            justify-content: center;
            margin: 0;
            margin-bottom: 15px !important;
          "
        >
          <div
            style="
              display: flex;
              align-items: center;
              flex-direction: row !important;
              min-height: 75px;
            "
          >
            <div
              style="
                padding-left: 50px;
                font-size: 18px;
                display: flex;
                align-items: center;
                cursor: pointer;
              "
              @click="toggleInvestorReports()"
              class="col-6"
            >
              Reports
              <i
                style="font-size: 10px; padding-left: 20px"
                :class="
                  showInvestorReports ? 'fa fa-arrow-up' : 'fa fa-arrow-down'
                "
              ></i>
            </div>
          </div>
          <div
            :style="showInvestorReports ? 'display: block' : 'display: none'"
            style="min-height: 100px"
          >
            <div class="col-12 investorInfoClass" style="padding-bottom: 25px">
              <table style="width: 100%">
                <thead>
                  <tr style="text-align: center">
                    <th>#</th>
                    <th>Contract</th>
                    <th>Year</th>
                    <th>ROI(%)</th>
                    <th>Grade</th>
                    <th>Status</th>
                    <th>View</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    style="text-align: center"
                    v-for="(report, key) in sortedReports"
                    :key="key"
                  >
                    <td>{{ key + 1 }}</td>
                    <td>{{ report.contract.code }}</td>
                    <td>{{ report.plan_report.year }}</td>
                    <td>{{ report.plan_report.roi }}</td>
                    <td>{{ report.plan_report.grade }}</td>
                    <td>
                      {{ report.consented ? "Consented" : "Unconsented" }}
                    </td>
                    <td>
                      <i
                        style="cursor: pointer"
                        @click="redirectToReport(report)"
                        class="fa fa-eye"
                      ></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </md-card>
      </div>
      <div class="col-10">
        <md-card
          class="md-card-stats"
          style="
            display: flex;
            justify-content: center;
            margin: 0;
            margin-bottom: 15px !important;
          "
        >
          <div
            style="
              display: flex;
              align-items: center;
              flex-direction: row !important;
              min-height: 75px;
            "
          >
            <div
              style="
                padding-left: 50px;
                font-size: 18px;
                display: flex;
                align-items: center;
                cursor: pointer;
              "
              @click="toggleInvestorAccounts()"
              class="col-6"
            >
              Account Transactions
              <i
                style="font-size: 10px; padding-left: 20px"
                :class="
                  showInvestorAccounts ? 'fa fa-arrow-up' : 'fa fa-arrow-down'
                "
              ></i>
            </div>
          </div>
          <div
            :style="showInvestorAccounts ? 'display: block' : 'display: none'"
            style="min-height: 100px"
          >
            <div class="col-12 investorInfoClass" style="padding-bottom: 25px">
              <table style="width: 100%">
                <thead>
                  <tr style="text-align: center">
                    <th>#</th>
                    <th>Date</th>
                    <th>Type</th>
                    <th>Amount</th>
                    <th>Exchange Rate</th>
                    <th>Final Amount (USD)</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    style="text-align: center"
                    v-for="(transaction, key) in investorTransactions"
                    :key="key"
                  >
                    <td>{{ key + 1 }}</td>
                    <td>{{ transaction.date }}</td>
                    <td>
                      {{
                        transactionTypes.find((type) => {
                          return type.id == transaction.type;
                        }).name
                      }}
                    </td>
                    <td>
                      {{ fixNumberView(transaction.amount) }}
                      {{ transaction.currency.code }}
                    </td>
                    <td>
                      {{ transaction.exchange_rate }}
                    </td>
                    <td>
                      {{
                        fixNumberView(
                          transaction.amount * transaction.exchange_rate
                        )
                      }}
                      USD
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </md-card>
      </div>
      <div class="col-10">
        <md-card
          class="md-card-stats"
          style="
            display: flex;
            justify-content: center;
            margin: 0;
            border-bottom-right-radius: 30px;
            border-bottom-left-radius: 30px;
          "
        >
          <div
            style="
              display: flex;
              align-items: center;
              flex-direction: row !important;
              min-height: 75px;
            "
          >
            <div
              style="
                padding-left: 50px;
                font-size: 18px;
                display: flex;
                align-items: center;
                cursor: pointer;
              "
              @click="toggleInvestorFiles()"
              class="col-6"
            >
              Files
              <i
                style="font-size: 10px; padding-left: 20px"
                :class="
                  showInvestorFiles ? 'fa fa-arrow-up' : 'fa fa-arrow-down'
                "
              ></i>
            </div>
          </div>
          <div
            :style="showInvestorFiles ? 'display: block' : 'display: none'"
            style="min-height: 100px"
          >
            <div class="col-12 investorInfoClass" style="padding-bottom: 25px">
              <table style="width: 100%">
                <thead>
                  <tr style="text-align: center">
                    <th>#</th>
                    <th>File Name</th>
                    <th>File Type</th>
                    <th>File Size</th>
                    <th>Download</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    style="text-align: center"
                    v-for="(file, key) in activeInvestor.files"
                    :key="key"
                  >
                    <td>{{ key + 1 }}</td>
                    <td>
                      {{
                        file.investor_file.caption
                          .split(".")
                          .slice(0, -1)
                          .join(".")
                      }}
                    </td>
                    <td>{{ file.investor_file.extension }}</td>
                    <td>{{ bytesToSize(file.investor_file.size) }}</td>
                    <td>
                      <a
                        style="color: rgb(140, 198, 63) !important"
                        :href="file.investor_file.url"
                        target="_blank"
                        download
                      >
                        <i class="fa fa-download"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </md-card>
      </div>
    </div>
  </div>
</template>
<script>
import Spinner from "vue-simple-spinner";
import sweetAlert from "sweetalert2";
import { mapState } from "vuex";
import InvestorsFilter from "../../filters/InvestorsFilter";
import TransactionsFilter from "../../filters/TransactionsFilter";
import moment from "moment";
import InvestorReportsFilter from "../../filters/InvestorReportsFilter";

export default {
  name: "investor",
  data() {
    return {
      showInvestorContracts: false,
      showInvestorReports: false,
      showInvestorAccounts: false,
      showInvestorFiles: false,
      investorID: null,
      investorCode: null,
      transactionTypes: [
        { id: "deposit", name: "Deposit" },
        { id: "withdrawal", name: "Withdrawal" },
      ],
      statusList: [
        { id: "active", name: "Active" },
        { id: "inactive", name: "InActive" },
        { id: "notstarted", name: "Not Started" },
        { id: "closed", name: "Closed" },
      ],
    };
  },
  created: function () {
    this.investorID = this.$route.params.investorId;
    this.investorCode = this.$route.params.investorCode;
    var investorsFilter = InvestorsFilter();
    investorsFilter.ids = [this.investorID];
    investorsFilter.with = ["account", "contracts"];
    this.$store
      .dispatch("searchInvestors", {
        filter: investorsFilter,
        resultMode: "default",
      })
      .then(() => {
        var transactionsFilter = TransactionsFilter();
        transactionsFilter.account_ids = [this.activeInvestor.account_id];
        transactionsFilter.account_types = ["investor_account"];
        this.$store.dispatch("searchTransactions", {
          filter: transactionsFilter,
          resultMode: "default",
        });
      });
    var investorReportsFilter = InvestorReportsFilter();
    investorReportsFilter.investor_ids = [this.investorID];
    investorReportsFilter.with = ["planReport"];
    investorReportsFilter.appends = ["contract"];
    this.$store.dispatch("searchInvestorReports", {
      filter: investorReportsFilter,
      resultMode: "default",
    });
  },
  components: {
    Spinner,
  },
  computed: {
    sortedReports() {
      return [...this.investorReports].sort(
        (a, b) => a.plan_report.year - b.plan_report.year
      );
    },
    ...mapState({
      authUser: (state) => state.userStore.authUser,
      activeInvestor: (state) =>
        state.investorStore.investorSearch.investors[0],
      investorTransactions: (state) =>
        state.transactionStore.transactionSearch.transactions,
      investorReports: (state) =>
        state.investorReportStore.investorReportSearch.investorReports,
      deleteInvestorStatus: (state) =>
        state.investorStore.investorDelete.deleteInvestorStatus,
      searchingInvestor: (state) =>
        state.investorStore.investorSearch.searchingInvestors,
    }),
    moment() {
      return moment;
    },
  },
  methods: {
    getContractDuration(start, end) {
      let duration = moment.duration(moment(start).diff(moment(end)));
      let durationString = "";
      if (duration.years() / -1) {
        durationString += duration.years() / -1 + " Years, ";
      }
      if (duration.months() / -1) {
        durationString += duration.months() / -1 + " Months, ";
      }
      if (duration.days() / -1) {
        durationString += duration.days() / -1 + " Days, ";
      }
      durationString = durationString.substring(0, durationString.length - 2);
      return durationString;
    },
    fixNumberView(value) {
      const numFor = Intl.NumberFormat("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 4,
      });
      return value < 0
        ? "(" + Math.abs(value).toLocaleString() + ")"
        : numFor.format(value);
    },
    toggleInvestorContracts() {
      this.showInvestorContracts = !this.showInvestorContracts;
    },
    toggleInvestorReports() {
      this.showInvestorReports = !this.showInvestorReports;
    },
    toggleInvestorAccounts() {
      this.showInvestorAccounts = !this.showInvestorAccounts;
    },
    toggleInvestorFiles() {
      this.showInvestorFiles = !this.showInvestorFiles;
    },
    bytesToSize(bytes) {
      var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      if (bytes === 0) return "0 Byte";
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
    },
    dateDifference(date2, date1) {
      const _MS_PER_DAY = 1000 * 60 * 60 * 24;

      // Discard the time and time-zone information.
      const utc1 = Date.UTC(
        date1.getFullYear(),
        date1.getMonth(),
        date1.getDate()
      );
      const utc2 = Date.UTC(
        date2.getFullYear(),
        date2.getMonth(),
        date2.getDate()
      );

      return Math.floor((utc2 - utc1) / _MS_PER_DAY);
    },
    viewAsInvestor() {
      this.$router.push(
        "/" +
          this.authUser.userable_type +
          "/investor/" +
          this.activeInvestor.code +
          "/dashboard/" +
          this.activeInvestor.id
      );
    },
    redirectToReport(report) {

      this.$router.push(
        "/" +
          this.authUser.userable_type +
          "/investor/" +
          this.activeInvestor.code +
          "/" +
          this.activeInvestor.id +
          "/contract/" +
          report.contract.code +
          "/" +
          report.contract.id +
          "/report/" +
          report.plan_report.year
      );
    },
    redirectToUpdateInvestor() {
      this.$router.push(
        "/" +
          this.authUser.userable_type +
          "/investor/" +
          this.activeInvestor.code +
          "/update/" +
          this.activeInvestor.id
      );
    },
    redirectToUpdateContract(contract) {
      this.$router.push(
        "/" +
          this.authUser.userable_type +
          "/investor/" +
          contract.investor_id +
          "/contract/update/" +
          contract.id
      );
    },
    deleteInvestor() {
      sweetAlert({
        title: "Confirmation",
        text: "Are you sure you want to delete this investor?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.value) {
          this.$store.dispatch("deleteInvestor", this.activeInvestor.id);
        }
      });
    },
  },
  watch: {
    deleteInvestorStatus() {
      if (this.deleteInvestorStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Investor has been deleted successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.$router.push("/" + this.authUser.userable_type + "/investors");
        });
      } else if (this.deleteInvestorStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Investor delete has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
  },
};
</script>
<style>
.investorInfoClass {
  padding-left: 75px;
  display: flex;
  align-items: start;
}
</style>


// WEBPACK FOOTER //
// resources/js/pages/admin/investor.vue